// src/pages/SecurityLogin.js

import React, { useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

// SecurityLogin component handles authentication for security officers using a unique code.
const SecurityLogin = () => {
  const [code, setCode] = useState('');
  const navigate = useNavigate();

  // Handles the login logic: checks if the entered code exists in Firestore
  const handleLogin = async (e) => {
    e.preventDefault();

    const trimmedCode = code.trim();
    if (!trimmedCode) {
      alert('Please enter your security code.');
      return;
    }

    try {
      const q = query(
        collection(db, 'security_officers'),
        where('code', '==', trimmedCode)
      );
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        sessionStorage.setItem('securityCode', trimmedCode);
        navigate('/security-dashboard');
      } else {
        alert('Invalid Code');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  // Renders the login form with input and submit button
  return (
    <div style={{ padding: '2rem' }}>
      <h2>Security Officer Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Enter Unique Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        <button type="submit" style={{ marginLeft: '1rem' }}>Login</button>
      </form>
    </div>
  );
};

export default SecurityLogin;
